import React from "react";
import "./NotesInput.scss";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

function NotesInput(props) {
	let { id } = props;
	const [value, setValue] = React.useState(props.value);
	const Dialog = withReactContent(Swal);

	const showPromptModal = () => {
		Dialog.fire({
			title: 'Add a note',
			imageUrl: props.image,
			imageWidth: 200,
			input: 'textarea',
			inputLabel: props.title,
			inputValue: props.value || "",
			reverseButtons: true,
			inputValidator: response => {
				if (!response) {
					return "You need to write something!";
				}
			},
			showCancelButton: true,
			confirmButtonText: "Save",
		}).then(result => {
			if (!result.isConfirmed) {
				return;
			}
			setValue(result.value);
			typeof props.onChange === "function" && props.onChange(result.value);
			Dialog.fire({
				title: 'Note added',
				icon: 'success',
				timerProgressBar: true,
				timer: 1500
			});
		});
	};

	const defaultTooltip = !props.isLocked
		? (<Tooltip className="_boss tooltip-info">
			Have something specific to say about this item? Use Notes to
			communicate requests and questions effectively with us.
		</Tooltip>)
		: (<></>)

	return (
		<>
			<div
				id={id}
				onClick={() => !props.isLocked ? showPromptModal() : props.onChange(props.value)}
				className={"notes-input" + (value ? " has-value" : "")}
			>
				{value ? (
					<OverlayTrigger
						placement="top"
						animation="true"
						delay={{ show: 250, hide: 400 }}
						overlay={<Tooltip className="_boss tooltip-info">{value}</Tooltip>}
					>
						<i className="far fa-comment-alt"></i>
					</OverlayTrigger>
				) : (
					<OverlayTrigger
						placement="top"
						animation="true"
						delay={{ show: 250, hide: 400 }}
						overlay={defaultTooltip}
					>
						<i className="far fa-comment-alt"></i>
					</OverlayTrigger>
				)}
			</div>
		</>
	);
}

export default NotesInput;
